import types from './types';

export function enterEntity({ id, type }) {
  return {
    type: types.ENTER_ENTITY,
    payload: {
      id,
      type,
    },
  };
}

export function leaveEntity({ id, type }) {
  return {
    type: types.LEAVE_ENTITY,
    payload: {
      id,
      type,
    },
  };
}

export function unsetHoverState() {
  return {
    type: types.UNSET_HOVER_STATE,
    payload: null,
  };
}

export function setBounds(bounds) {
  return {
    type: types.SET_BOUNDS,
    payload: bounds,
  };
}

export function setAllFeatureBounds(allFeatureBounds) {
  return {
    type: types.SET_ALL_FEATURE_BOUNDS,
    payload: allFeatureBounds,
  };
}

export function setCenter(center) {
  return {
    type: types.SET_CENTER,
    payload: center,
  };
}

export function closeMapPanel() {
  return {
    type: types.CLOSE_MAP_PANEL,
  };
}

export function openMapPanel() {
  return {
    type: types.OPEN_MAP_PANEL,
  };
}

export function setViewMode(viewMode) {
  return {
    type: types.SET_VIEW_MODE,
    payload: viewMode,
  };
}



// WEBPACK FOOTER //
// ./src/state/ducks/map/actions.js